import Tooltip from '@mui/material/Tooltip'
import { useState } from 'react'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { TeamNoteForm } from './TeamNoteForm'
import { RcIconButton } from '@/components/molecules/interactive/RcIconButton'
import { ModalTrigger } from '@/components/organisms/modal/ModalTrigger'
import { useCompetitionTeamNote } from '@/entity/competition-team/useCompetitionTeamNote'
import { MarkdownDisplay } from '@/components/molecules/input/MarkdownDisplay'
import { RcTrans } from '@/components/atoms/RcTrans'

export const TeamNoteIcon = ({ onComplete }: { onComplete?: () => any }) => {
  const [hovered, setHovered] = useState(false)
  const { hasNote, note } = useCompetitionTeamNote({
    paused: !hovered
  })

  return (
    <ModalTrigger
      activation={handleOpen => (
        <Tooltip
          title={
            <Stack direction='column' spacing={2}>
              <Box>
                <Typography variant='h3' sx={{ minWidth: 300 }}>
                  <RcTrans i18nKey='competition:moderator-note' />
                </Typography>
                <Typography variant='subtitle2' color='text.secondary'>
                  (
                  <RcTrans i18nKey='competition:moderator-visibilty' />)
                </Typography>
              </Box>
              <Divider />
              <MarkdownDisplay markdown={note?.value} />
            </Stack>
          }
          onMouseEnter={() => setHovered(true)}
        >
          <RcIconButton
            onClick={handleOpen}
            icon={['fal', 'sticky-note']}
            color={hasNote ? 'warning' : undefined}
          />
        </Tooltip>
      )}
    >
      {({ handleClose }) => (
        <TeamNoteForm
          onComplete={() => {
            handleClose()
            onComplete?.()
          }}
        />
      )}
    </ModalTrigger>
  )
}
